import { ExternalLink, ShieldCheck, Smartphone } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import BrandMark from '@/components/BrandMark';

const SAFE_TOKEN = /^[A-Za-z0-9_-]{32,128}$/;

export default function MatchClaimLandingPage() {
  const { token = '' } = useParams();
  const valid = SAFE_TOKEN.test(token);
  const appLink = valid ? `playtark://match-claim/${encodeURIComponent(token)}` : null;

  return (
    <div className="public-theme min-h-screen bg-background text-text">
      <div className="mx-auto flex min-h-screen w-full max-w-xl flex-col px-4 py-5 sm:px-6 sm:py-7">
        <header className="border-b border-border pb-4"><BrandMark size="sm" titleClassName="text-lg" /></header>
        <main className="flex flex-1 items-center py-10">
          <section className="w-full rounded-2xl border border-border bg-surface p-6 shadow-sm sm:p-8" aria-labelledby="claim-title">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
              {valid ? <Smartphone aria-hidden className="h-7 w-7" /> : <ShieldCheck aria-hidden className="h-7 w-7" />}
            </div>
            <p className="mt-5 text-sm font-semibold text-primary">TARK match invitation</p>
            <h1 id="claim-title" className="mt-1 text-3xl font-bold leading-tight">
              {valid ? 'Claim your player slot' : 'This link is not valid'}
            </h1>
            <p className="mt-3 leading-relaxed text-text-muted">
              {valid
                ? 'Open this invitation in the TARK app. Sign in or create an account, review the score, and choose whether to confirm it. Claiming alone never changes your rating.'
                : 'Ask the person who recorded the match to create and share a new claim link.'}
            </p>
            {appLink ? (
              <div className="mt-7 grid gap-3">
                <a href={appLink} className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-xl bg-primary px-5 py-3 font-semibold [color:var(--color-on-primary)]">
                  Open in TARK<ExternalLink aria-hidden className="h-4 w-4" />
                </a>
                <Link to="/releases?view=install" className="inline-flex min-h-[48px] items-center justify-center rounded-xl border border-border px-5 py-3 font-semibold text-primary hover:border-primary">
                  Install or update TARK
                </Link>
              </div>
            ) : null}
            <p className="mt-6 text-xs leading-relaxed text-text-muted">
              The private claim code expires after 30 days. TARK does not publish an unconfirmed result or use it for ratings.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
}
